// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-rules/modules/rule-edit-form/rule-edit-form.less
// module id = 3593
// module chunks = 0